export default {
  index: {
    title: '澳門醫療預約',
    banner: {
      smartMedical: '智慧醫療',
      convenientService: '便捷預約，優質服務',
      specializedMedical: '特色診療',
      crossBorder: '中醫特色，跨境醫療'
    },
    quickEntry: {
      appointment: '預約掛號',
      vaccine: '疫苗接種',
      records: '就醫記錄',
      department: '科室導航'
    },
    news: {
      title: '醫院資訊',
      vaccine: '澳門特區新增疫苗接種點',
      cooperation: '大灣區醫療合作新進展'
    },
    featured: {
      title: '大灣區特色醫療',
      tcm: '中醫特色診療',
      tcmDesc: '傳統中醫，現代科技',
      crossBorder: '跨境醫療服務',
      crossBorderDesc: '便捷通關，無縫銜接',
      expert: '專家門診',
      expertDesc: '名醫匯聚，專業診療'
    }
  },
  tabbar: {
    home: '首頁',
    appointment: '預約',
    my: '我的'
  },
  common: {
    confirm: '確認',
    cancel: '取消',
    loading: '加載中...',
    more: '更多',
    viewAll: '全部',
    viewMore: '查看更多',
    search: {
      placeholder: '搜索科室/醫生/疾病'
    },
    language: {
      select: '選擇語言'
    },
    tag: {
      new: '最新'
    },
    status: {
      available: '可預約',
      busy: '較忙',
      full: '已滿'
    },
    unit: {
      person: '人',
      km: '公里',
      score: '分'
    }
  },
  department: {
    search: {
      tabs: {
        department: '科室',
        doctor: '醫生',
        disease: '疾病'
      },
      result: {
        doctorCount: '{count}位醫生',
        rating: '評分',
        distance: '距離',
        book: '預約掛號'
      }
    },
    category: {
      all: '全部科室',
      internal: '內科',
      surgery: '外科',
      pediatrics: '兒科',
      gynecology: '婦產科',
      ent: '五官科',
      tcm: '中醫科',
      covid: '冠狀病毒疫苗',
      flu: '流感疫苗',
      hpv: 'HPV疫苗',
      child: '兒童疫苗'
    }
  },
  appointment: {
    title: '預約掛號',
    search: {
      placeholder: '搜索科室/醫生/疾病'
    }
  }
} 